import { createEffect } from "solid-js"
import { DoubleSide, Group, Mesh, MeshBasicMaterial, PlaneGeometry, Vector3 } from "three"
import { dijkstraDirections } from "../../core/direction/dijkstraDirections"
import { type DirectionDxDy } from "../../core/direction/DirectionDxDy.type"
import type { Engine } from "../../core/engine/Engine.type"
import { ELEVATION_ABSOLUTE_MIN, ELEVATION_SIZE } from "../../core/entity/EntityElevation/elevation_consts"
import { HALF_PI } from "../../core/util/math/Math"
import { VERTICES_PER_TILE } from "../consts"
import { RenderOrder } from "../RenderOrder.enum"
import useMainScene from "./useMainScene"

const bottomY = 40
export default function createMapEditorEdgeWallsGroupV2(
  engine: Engine,
): void {
  // console.log('createMapEditorEdgeWallsGroupV2')
  const scene = useMainScene(engine)

  const group: Group = new Group()
  group.name = 'MapEditorEdgeWallsGroup'
  group.renderOrder = RenderOrder.MapGridBorderWalls

  const dirWallGroupMap = new Map<DirectionDxDy, Mesh>

  const geometry = new PlaneGeometry(1, 1)
  const material = new MeshBasicMaterial({
    color: 0x333333,
    // color: 0xffff00,
    // opacity: 0.25,
    side: DoubleSide,
    transparent: true,
    // color: 0x000000,
    // opacity: 0.25,
  })

  const whDiv = 4

  for (const dir of dijkstraDirections) {
    const { dx, dy } = dir
    const mesh = new Mesh(geometry, material)
    if (dy !== 0) {
      mesh.rotateZ(HALF_PI)
    } else {
      mesh.rotateY(HALF_PI)
    }
    mesh.position.set(dx, bottomY, dy)
    mesh.scale.multiply(new Vector3(
      VERTICES_PER_TILE / whDiv,
      VERTICES_PER_TILE / whDiv,
      VERTICES_PER_TILE))
    group.add(mesh)

    dirWallGroupMap.set(dir, mesh)
  }

  // console.log('group', group)

  const mult = VERTICES_PER_TILE
  createEffect(() => {
    const { width, height } = engine.state
    // console.log('effect', {width, height})

    const offsetX = ((width - 1) * VERTICES_PER_TILE / 2)
    const offsetZ = ((height - 1) * VERTICES_PER_TILE / 2)

    dirWallGroupMap.forEach((mesh, dir: DirectionDxDy) => {
      const { dx, dy } = dir
      const { position, scale } = mesh
      // const scaleValue = 1.4
      if (dy !== 0) {
        // mesh.position.z = mult * dy * (width/2)
        position.z = (mult * dy * (height / 2)) + offsetZ
        position.x = offsetX
        // console.log('dy', dy, position.z)
        scale.y = mult * dy * width
      } else {
        // position.x = mult * dx * (height/2)
        position.x = (mult * dx * (width / 2)) + offsetX
        position.z = offsetZ
        scale.x = mult * dx * height
      }
      position.y = 0
    })
  })

  // the giant endless floor plain
  const floorMaterial = new MeshBasicMaterial({
    // color: 0x111111,
    color: 0x000000,
    // color: 0xff0000,
    // transparent: true,
    // opacity: 0.5,
  })

  const floorMesh = new Mesh(geometry, floorMaterial)
  floorMesh.rotateX(-HALF_PI)
  floorMesh.position.y = ELEVATION_ABSOLUTE_MIN * ELEVATION_SIZE - 0.1
  group.add(floorMesh)
  floorMesh.scale.multiplyScalar(100000)

  scene.add(group)
}
